import React, { useEffect, useState } from "react";
import { lib } from "../index";
import ConfigCenter from "../config-center/config-center";
import { Button, message, Space, Modal, Switch, Select, Input, Form, Typography, Divider, Alert } from "antd";
import "./account.less";
import { ExclamationCircleFilled } from "@ant-design/icons";
import HOC from "../util/HOC";

const { Title, Paragraph } = Typography;

function CreateOrUpdateRole({ row, reload }) {
    let [visible, setVisible] = useState(false);
    const [form] = Form.useForm();
    let target = lib.config.webToken == "admin" ? "/ucenter-admin" : "/ucenter-customer";
    useEffect(() => {
        form.setFieldsValue(row);
    }, [row]);
    return (
        <>
            {visible && (
                <Modal
                    open={true}
                    title={row ? "编辑角色" : "新增角色"}
                    onCancel={() => setVisible(false)}
                    onOk={() => {
                        form.validateFields().then(values => {
                            let data = {
                                ...values,
                                systemCode: lib.config.systemCode,
                            };
                            let url = `${target}/role/create`;
                            if (row) {
                                url = `${target}/role/update`;
                                data.id = row.id;
                            }
                            lib.request({
                                url: url,
                                data,
                                needMask: true,
                                success: () => {
                                    if (!row) {
                                        form.resetFields();
                                    }
                                    message.success("操作成功");
                                    setVisible(false);
                                    reload();
                                },
                            });
                        });
                    }}>
                    <Form
                        form={form}
                        layout="horizontal"
                        name="form_in_modal"
                        labelCol={{ span: 5 }}
                        wrapperCol={{ span: 16 }}>
                        <Form.Item name="name" label="角色名称" rules={[{ required: true, message: "请输入角色名称" }]}>
                            <Input maxLength={128} placeholder={"请输入角色名称，字数不超过128位"} />
                        </Form.Item>
                        <Form.Item name="remark" label="角色简介">
                            <Input.TextArea maxLength={512} showCount placeholder={"请输入角色简介，字数不超过512位"} />
                        </Form.Item>
                    </Form>
                </Modal>
            )}
            {row ? (
                <div className="link" onClick={() => setVisible(true)}>
                    编辑
                </div>
            ) : (
                <Button type="primary" onClick={() => setVisible(true)}>
                    新增角色
                </Button>
            )}
        </>
    );
}

@HOC.mapAuthButtonsToState({ pagePath: "/role-manage" })
class RoleManage extends ConfigCenter {
    constructor(props) {
        super(props);
        this.state.buttons = [];
    }

    isContainCode(code) {
        return this.state.buttons.includes(code);
    }

    load(needMask) {
        let { pagination, searchConditions } = this.state;
        var data = {};
        Object.assign(data, pagination, searchConditions, { systemCode: lib.config.systemCode });
        lib.request({
            url: this.state.config.requestUrl,
            data: data,
            needMask: needMask,
            success: data => {
                this.setState({
                    pagination: data.page,
                    dataList: data.dataList || [],
                });
                this.tablePanel.scrollTop = 0;
            },
        });
    }

    reload() {
        this.state.pagination.currentPage = 1;
        this.load();
    }

    renderRightOperation() {
        return (
            <Space>
                {this.isContainCode("create") && <CreateOrUpdateRole reload={this.reload.bind(this)} />}
                {lib.config.webToken == "admin" ? (
                    <Button onClick={() => lib.openPage("/admin-role-log?page_title=操作日志")}>操作日志</Button>
                ) : (
                    <Button onClick={() => lib.openPage("/web-role-log?page_title=操作日志")}>操作日志</Button>
                )}
            </Space>
        );
    }

    getStatus(row) {
        return (
            this.isContainCode("enable") && (
                <Switch
                    checked={row.status == 1}
                    onChange={checked => {
                        row.status = checked + 0;
                        this.setState(this.state);
                        let url =
                            lib.config.webToken == "admin"
                                ? "/ucenter-admin/role/enable"
                                : "/ucenter-customer/role/enable";
                        lib.request({
                            url,
                            data: row,
                            needMask: true,
                            success: () => message.success("操作成功"),
                            fail: this.load.bind(this),
                        });
                    }}
                />
            )
        );
    }

    getUserCount(row) {
        return (
            <div /*onClick={() => lib.openPage(`/role-add-account?page_title=角色【${row.name}】添加成员&roleId=${row.id}`)}*/
            >
                {row.userCount}
            </div>
        );
    }

    deleteRole(row) {
        lib.request({
            url:
                lib.config.webToken === "admin"
                    ? "/ucenter-admin/role/checkDelete"
                    : "/ucenter-customer/role/checkDelete",
            data: { id: row.id },
            needMask: true,
            success: res => {
                if (res) {
                    this.showDeleteRoleConfirm(row.id);
                } else {
                    this.showDeleteRoleHasBinderConfirm(row);
                }
            },
        });
    }

    myOperation(row) {
        return (
            <Space>
                {this.isContainCode("see-detail") && (
                    <div
                        className="link"
                        onClick={() =>
                            lib.openPage(
                                `/permission-manage?page_title=${row.systemName}权限分配&roleId=${row.id}&isDetail=true`,
                            )
                        }>
                        查看
                    </div>
                )}
                <div className="link" onClick={() => this.addAccount(row)}>
                    {lib.config.webToken === "admin" ? "添加用户" : "添加员工"}
                </div>
                {this.isContainCode("permissionUpdate") && (
                    <div
                        className="link"
                        onClick={() =>
                            lib.openPage(`/permission-manage?page_title=${row.systemName}权限分配&roleId=${row.id}`)
                        }>
                        权限分配
                    </div>
                )}
                {this.isContainCode("update") && <CreateOrUpdateRole row={row} reload={this.reload.bind(this)} />}
                {this.isContainCode("delete") && (
                    <div className="link" onClick={this.deleteRole.bind(this, row)}>
                        删除
                    </div>
                )}
            </Space>
        );
    }

    addAccount(row) {
        const text = lib.config.webToken === "admin" ? "添加用户" : "添加员工";
        lib.openPage(
            `/role-add-account?page_title=角色【${row.name}】${text}&roleId=${row.id}&roleName=${row.name}`,
            () => {
                this.reload();
            },
        );
    }

    showDeleteRoleHasBinderConfirm(row) {
        const modal = Modal.warning({
            title: "当前角色下有绑定帐户，不可删除",
            content: (
                <span
                    className={"link"}
                    onClick={() => {
                        modal.destroy();
                        this.addAccount(row);
                    }}>
                    请解除绑定后继续操作
                </span>
            ),
            icon: <ExclamationCircleFilled />,
            okText: "我知道了",
        });
    }

    showDeleteRoleConfirm = id => {
        const reload = this.reload.bind(this);
        Modal.confirm({
            title: "确定删除当前角色？",
            icon: <ExclamationCircleFilled />,
            okText: "确定",
            okType: "danger",
            cancelText: "取消",
            onOk() {
                return new Promise((resolve, reject) => {
                    lib.request({
                        url:
                            lib.config.webToken === "admin"
                                ? "/ucenter-admin/role/delete"
                                : "/ucenter-customer/role/delete",
                        data: { id },
                        needMask: true,
                        success: res => {
                            reload();
                            resolve();
                        },
                        fail: e => {
                            reject(e);
                        },
                    });
                }).catch(() => console.log("Oops errors!"));
            },
        });
    };
}

export default props => {
    let requestUrl = lib.config.webToken == "admin" ? "/ucenter-admin/role/page" : "/ucenter-customer/role/page";
    var config = {
        id: 160239269089711,
        searchKeyList: [
            {
                id: 1602392705930741,
                label: "角色名称",
                key: "name",
                type: "text",
                extra: "",
            },
            {
                id: 1602392706817861,
                label: "启用状态",
                key: "status",
                type: "json-select",
                extra: '[{"id":"0","name":"禁用"},{"id":"1","name":"启用"}]',
            },
            {
                id: 1602392707297479,
                label: "创建时间",
                key: "createdAtStart,createdAtEnd",
                type: "date",
                extra: "",
            },
            {
                id: 1602392707962437,
                label: "更新时间",
                key: "updatedAtStart,updatedAtEnd",
                type: "date",
                extra: "",
            },
        ],
        requestUrl,
        tableFieldList: [
            {
                id: 1602392747953582,
                title: "角色名称",
                key: "name",
                type: "text",
                width: "200",
                display: "auto",
            },
            {
                id: 1602392751273722,
                title: "角色简介",
                key: "remark",
                type: "text",
                width: "200",
                display: "auto",
            },
            {
                id: 1602392751769505,
                title: "关联人数",
                key: "getUserCount",
                type: "function",
                width: "100",
                display: "auto",
            },
            {
                id: 1602392748609958,
                title: "启用状态",
                key: "getStatus",
                type: "function",
                width: "100",
                display: "auto",
            },
            {
                id: 1602392750129599,
                title: "创建时间",
                key: "createdAt",
                type: "text",
                width: "130",
                display: "auto",
            },
            {
                id: 1602392750649118,
                title: "更新时间",
                key: "updatedAt",
                type: "text",
                width: "130",
                display: "auto",
            },
            {
                id: 1602392752473404,
                title: "操作",
                key: "myOperation",
                type: "function",
                width: "210",
                display: "sticky-right",
            },
        ],
        needBatchOperation: false,
        excel: {},
    };

    return <RoleManage {...props} config={config} />;
};
